import { MutationTree } from 'vuex';
import { AppInterface } from 'src/store/app/state';
import { Users } from 'src/api';
import User = Users.Types.User;

const mutation: MutationTree<AppInterface> = {
  SET_UNDEFINED_SERVER_ERROR(state: AppInterface, isError: boolean) {
    state.isUndefinedServerError = isError;
  },

  SET_USER(state: AppInterface, user: User | null) {
    state.user = user;
  },

  SET_HOST(state: AppInterface, host: string) {
    state.host = host;
  },

  SET_LEFT_DRAWER_OPEN(state: AppInterface, open: boolean) {
    state.isLeftDrawerOpen = open;
  },

  SET_PAGE_TITLE(state: AppInterface, title: string) {
    state.pageTitle = title;
  },
};

export default mutation;
